import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ModalStateService } from 'src/app/services/modal-service/modal-state.service';

export interface ConditionalModalOptions {
  message?: string;
  iconName?: string;
  iconColor?: string;
  iconSize?: string;
  okButtonText?: string;
  okButtonColor?: string;
  noButtonText?: string;
  noButtonColor?: string;
}

@Component({
  selector: 'app-condition',
  templateUrl: './condition.component.html',
  styleUrls: ['./condition.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule]
})
export class ConditionComponent {

  readonly config = input<ConditionalModalOptions>({});

  readonly message = computed(() => this.config().message ?? 'MODAL.DEFAULTMESSAGE.CONDITIONAL');
  readonly iconName = computed(() => this.config().iconName ?? 'help-circle-outline');
  readonly iconColor = computed(() => this.config().iconColor ?? 'warning');
  readonly iconSize = computed(() => this.config().iconSize ?? '4.5em');
  readonly okButtonText = computed(() => this.config().okButtonText ?? 'BTN.OK');
  readonly okButtonColor = computed(() => this.config().okButtonColor ?? 'success');
  readonly noButtonText = computed(() => this.config().noButtonText ?? 'BTN.NO');
  readonly noButtonColor = computed(() => this.config().noButtonColor ?? 'danger');

  modalState: ModalStateService;

  constructor() {
    this.modalState = inject(ModalStateService);
  }

  close(result: boolean) {
    this.modalState.triggerDismiss("conditional", result);
  }
}